var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3178 0.539231L11.2985 0.521666C10.9303 0.185278 10.4529 0 9.95434 0C9.39544 0 8.85882 0.236596 8.48203 0.649068L1.35752 8.44898C1.29258 8.52006 1.24333 8.60394 1.21288 8.69525L0.37514 11.2067C0.278282 11.497 0.326894 11.8181 0.505155 12.0656C0.684837 12.315 0.97431 12.4639 1.27956 12.4639H1.2796C1.41164 12.4639 1.54069 12.4368 1.66309 12.3832L4.08867 11.3221C4.17686 11.2835 4.25597 11.2269 4.32086 11.1558L11.4454 3.35591C12.1868 2.54431 12.1296 1.28085 11.3178 0.539231ZM1.98022 10.7427L2.4718 9.26906L2.51326 9.22366L3.44496 10.0747L3.40351 10.1201L1.98022 10.7427ZM10.4296 2.42801L4.37286 9.05888L3.44116 8.20789L9.49789 1.57697C9.61635 1.44727 9.77847 1.37582 9.95439 1.37582C10.1087 1.37582 10.2565 1.43324 10.3709 1.53771L10.3901 1.55528C10.6416 1.78499 10.6593 2.17651 10.4296 2.42801Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.8f82f6b9cff9c41c2709e1bf1e9353a9.svg";
export { ForwardRef as ReactComponent };